export default "__VITE_ASSET__bd240f79__"